export interface HeadingIdentity {
  readonly id: string;
  readonly recognized: boolean;
  readonly spoken: string;
}

const PARAGRAPHS: Readonly<Record<string, { id: string; spoken: string }>> = {
  SITUATION: { id: "SITUATION", spoken: "Situation" },
  MISSION: { id: "MISSION", spoken: "Mission" },
  EXECUTION: { id: "EXECUTION", spoken: "Execution" },
  "SERVICE SUPPORT": { id: "SERVICE", spoken: "Service and support" },
  "SERVICE AND SUPPORT": { id: "SERVICE", spoken: "Service and support" },
  "COMD & SIGS": { id: "COMDSIGS", spoken: "Command and signals" },
  "COMMAND AND SIGNALS": { id: "COMDSIGS", spoken: "Command and signals" },
};

const SUBPARAGRAPHS: Readonly<
  Record<string, Readonly<Record<string, { id: string; spoken: string }>>>
> = {
  SITUATION: {
    ENEMY: { id: "SITUATION/ENEMY", spoken: "Enemy" },
    FRIENDLY: { id: "SITUATION/FRIENDLY", spoken: "Friendly" },
    "ATTS AND DETS": {
      id: "SITUATION/ATTS",
      spoken: "Attachments and detachments",
    },
    "ATTACHMENTS AND DETACHMENTS": {
      id: "SITUATION/ATTS",
      spoken: "Attachments and detachments",
    },
  },
  EXECUTION: {
    "CONCEPT OF OPERATIONS": {
      id: "EXECUTION/CONOPS",
      spoken: "Concept of operations",
    },
    "GROUPINGS AND TASKS": {
      id: "EXECUTION/GT",
      spoken: "Groupings and tasks",
    },
    "COORDINATING INSTRUCTIONS": {
      id: "EXECUTION/COORD",
      spoken: "Coordinating instructions",
    },
  },
};

export function normalizeHeading(value: string): string {
  return value
    .trim()
    .replace(/\s*:\s*$/, "")
    .trim();
}

export function stableHeadingId(value: string): string {
  const normalized = normalizeHeading(value)
    .toUpperCase()
    .replaceAll("&", " AND ")
    .replace(/[^A-Z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

  return normalized === "" ? "UNNAMED" : normalized;
}

export function paragraphIdentity(value: string): HeadingIdentity {
  const normalized = normalizeHeading(value).toUpperCase();
  const match = PARAGRAPHS[normalized];

  return match === undefined
    ? {
        id: stableHeadingId(value),
        spoken: normalizeHeading(value),
        recognized: false,
      }
    : { ...match, recognized: true };
}

export function subparagraphIdentity(
  paragraphId: string,
  value: string,
): HeadingIdentity {
  const normalized = normalizeHeading(value).toUpperCase();
  const match = SUBPARAGRAPHS[paragraphId]?.[normalized];

  return match === undefined
    ? {
        id: `${paragraphId}/${stableHeadingId(value)}`,
        spoken: normalizeHeading(value),
        recognized: false,
      }
    : { ...match, recognized: true };
}
